import React, { Component, Fragment } from 'react'

import Template from './TemplateLandingPage'
import TwoCols from '../../../blocks/LandingPageBlocks/TwoCols'
import WhyUse from '../../../blocks/LandingPageBlocks/WhyUse'
import NewMenu from '../../../blocks/Menu/NewMenu'
import CenteredTitleSection from '../../../blocks/LandingPageBlocks/CenteredTitleSection'
import Hero from '../../../blocks/LandingPageBlocks/Hero'
import CardsEstrategias from '../../../blocks/CardsEstrategias/CardsEstrategias'

export default class SalesAutomationv2 extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Fragment>
                <NewMenu
                    pixelsToShowMenuWhite={50}
                    mutableMenu
                />
                <Template >
                    <Hero title={<Fragment><strong>Software de vendas</strong> da sua representação comercial</Fragment>}
                        description='Supere metas, organize pedidos, acompanhe seu desempenho e dos seus prepostos, libere tempo para vender mais e conquistar novos clientes.' />
                    <WhyUse title='Por que sua representação comercial precisa de um software de vendas?' image='man-taking-notes'>
                        <h3>Software de vendas é um sistema que tem recursos para aumentar a produtividade do representante na rua e a organização das indústrias e distribuidoras que recebem essas vendas.</h3>
                        <h3>Com o software de vendas Mercos, sua representação organiza as tabelas de preços e de produtos, emite e controla os pedidos de todas as suas representadas de forma padronizada, acompanha as vendas e performance dos seus prepostos, gera relatórios e controla o estoque dos produtos com poucos cliques. Já a empresa, recebe os pedidos padronizados e ainda consegue acompanhar as atividades dos seus representantes. E ainda oferece um aplicativo completo, fácil de usar e que funciona offline para facilitar o dia a dia do vendedor.</h3>
                    </WhyUse>
                    <CenteredTitleSection title="O software para potencializar e gerenciar vendas da sua representação" />
                    <TwoCols sectionName="representanteOrganizado" title="Representação organizada, ágil e que não precisa ter retrabalho" reverse />
                    <TwoCols sectionName="mobilidade" />
                    <TwoCols sectionName="potencializaRepresentante" reverse />
                    <TwoCols sectionName="semErros" />
                    <TwoCols sectionName="vendaOnline" reverse />
                    <CardsEstrategias title='Defina estratégias comerciais e acompanhe a execução' />
                </Template>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/RepresentationSoftwarev2.jsx